// extracted by mini-css-extract-plugin
export default {"primaryColor":"#354760","white":"#fff","container":"styles_container__a5tRu","status":"styles_status__+aPYs","statusLabel":"styles_statusLabel__96ljU"};